import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts.js';
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from 'components/misc/Headings';
import { SectionDescription } from 'components/misc/Typography';
import { ReactComponent as TwitterIcon } from 'images/twitter-icon.svg';
import { ReactComponent as LinkedinIcon } from 'images/linkedin-icon.svg';
import { ReactComponent as GithubIcon } from 'images/github-icon.svg';
import user from '../../images/user.png';

const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw(SectionDescription)`mx-auto text-center`;

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`;
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`;
const CardImage = styled.div`
  ${(props) =>
    css`
      background-image: url('${props.imageSrc}');
    `}
  ${tw`w-64 h-64 bg-contain bg-center rounded`}
`;
const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`;

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`;

export default ({
  heading = 'Meet Our Exemplary Leadership.',
  subheading = 'Our Team',
  description = 'Our dedicated leadership team, committed to guiding Bright Hope School towards continued excellence and success.',
  cards = [
    {
      imageSrc: user,
      position: 'Founder',
      name: 'Anna Pallangyo',
    },
    {
      imageSrc: user,
      position: 'Assistant Director',
      name: 'Nancy Cleopa',
    },
    {
      imageSrc: user,
      position: 'Manager',
      name: 'Assery Cleopa',
    },

    {
      imageSrc: user,
      position: 'Head Teacher',
      name: 'Bernadino Richard',
    },
    {
      imageSrc: user,
      position: 'Academic Dean',
      name: 'Katana Katana',
    },
    {
      imageSrc: user,
      position: 'Assistant Academic Dean',
      name: 'Jordaius Josephat',
    },
  ],
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} />
              <CardContent>
                <span className='position'>{card.position}</span>
                <span className='name'>{card.name}</span>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
